/**
 * Jeton d'accès public de la réponse de formulaire en cours.
 *
 * Remis par POST /public-survey-responses, il est exigé (en-tête
 * X-Survey-Response-Token) par toutes les routes publiques keyées par id :
 * lecture / sauvegarde de la réponse, upload, scan de pièce d'identité,
 * navigation entre sections, commandes du catalogue.
 *
 * Gardé EN MÉMOIRE, un par onglet : la clé localStorage `surveyResponseId` est
 * partagée entre onglets, la relire ici ferait envoyer le jeton d'un autre
 * formulaire ouvert à côté.
 */
export const SURVEY_RESPONSE_TOKEN_HEADER = 'X-Survey-Response-Token';

let surveyResponseToken: string | null = null;

export function setSurveyResponseToken(token: string | null | undefined): void {
    surveyResponseToken = token || null;
}

export function getSurveyResponseToken(): string | null {
    return surveyResponseToken;
}

export function clearSurveyResponseToken(): void {
    surveyResponseToken = null;
}

/** Routes publiques qui exigent le jeton (URL relative à la base de l'API). */
const TOKEN_ROUTES = [
    /^\/?public-survey-responses\//,
    /^\/?public-orders(\/|$)/,
    // Pas les variantes -preview du back-office.
    /^\/?survey-sections\/\d+\/(next|previous)-visible(\?|$)/,
    // Produits d'un catalogue : le jeton prouve le séjour, sans lui les choix déjà
    // faits dans les autres commandes du séjour ne sont pas renvoyés.
    /^\/?public-catalog-items\//,
];

export function requiresSurveyResponseToken(url: string | undefined): boolean {
    if (!url) return false;
    return TOKEN_ROUTES.some((pattern) => pattern.test(url));
}
